import { useAuditMention } from '@app/modules/audit/modules/station-audit/hooks/useAuditMention';
import { AuditLiveMention } from '@app/modules/audit/modules/station-audit/types';
import { AuditLiveMentionConfidence, AuditSchedule } from '@mi-front/core';
import { Box } from '@mui/material';
import { ConfirmedBySchedule } from '../audit-result/ConfirmedBySchedule';
import { MentionConfidence } from '../mentions/MentionConfidence';

export interface VerifyMatchMentionStatusProps {
  mention: AuditLiveMention;
}

/**
 * Live mention confidence chip (and linked schedule) for the verify-match dialog.
 */
export function VerifyMatchMentionStatus({ mention }: VerifyMatchMentionStatusProps) {
  const { data } = useAuditMention(mention.stationId, mention.id);
  const confidence = data?.confidence ?? mention.confidence ?? AuditLiveMentionConfidence.AUTO;

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <MentionConfidence value={confidence} />
      {mention.confirmedSchedule && (
        <ConfirmedBySchedule
          schedule={mention.confirmedSchedule as AuditSchedule}
          matchDatetime={mention.datetime}
          showDate
          schedulesListCategory="mentions"
        />
      )}
    </Box>
  );
}
